import { LibraryPage } from '@/features/library/LibraryPage';
import { useT } from '@/i18n/LocaleProvider';
import { useDocumentTitle } from '@/lib/useDocumentTitle';

export function LibraryRoute({ tab }: { tab: 'saved' | 'canvases' }) {
  const t = useT();
  useDocumentTitle(tab === 'saved' ? t('nav.saved') : t('nav.canvases'));
  return <LibraryPage tab={tab} />;
}
